<template>
  <div class="row pt-4">
    <div class="col-md-10 offset-md-1">
      <div class="card lists">
        <!-- overview of all the lists -->
        <div class="card-body py-3">
          <link-button
            v-if="isBookmarkFoldersLoaded && canEdit && !isEmpty(filteredUserFolders)"
            text="Create"
            icon="fa-plus"
            @click="handleCreate()"
            class="pull-right"
          />
          <h3>
            <i class="fa fa-folder t-secondary mr-2" />
            <template v-if="canEdit">
              My bookmark folders
            </template>
            <template v-else>
              Bookmark folders
            </template>
            <i v-if="isBookmarkFoldersLoaded && (isEmpty(userFolders) || !canEdit)" class="fa fa-list-ul d-block pull-right t-placeholder"></i>
            <span v-if="canEdit" class="t-xs t-regular"><br />Store your findings in a folder and invite others to view or change the content</span>
          </h3>

          <div v-if="isBookmarkFoldersLoaded" class="mt-3">
            <p v-if="isEmpty(filteredUserFolders) && canEdit" class="mb-0 mt-4 text-center">
              <i class="fa fa-plus d-block t-secondary"></i>
              <a href="#" @click.prevent="handleCreate()" class="t-sm">Start creating your first folder</a>
            </p>

            <p v-if="isEmpty(filteredUserFolders) && !canEdit" class="mb-0 mt-1 t-sm t-secondary">
              This user hasn't created any public bookmark folders yet
            </p>

            <div v-for="(bookmarkFolder, index) in filteredUserFolders" :key="index">
              <hr class="my-3 bd-color-light hr-outlined" />
              <bookmark-item
                :researcher="researcher"
                :user="user"
                :bookmarkFolder="bookmarkFolder"
              />
            </div>
          </div>

          <!-- render spinner if not loaded -->
          <spinner v-if="!isBookmarkFoldersLoaded" :containerClass="`width--50px min-height--150px`" />
        </div>

      </div>
      <div class="card lists mt-5">
        <div v-if="!$route.query.public && invitedFolders.length > 0" class="card-body py-3">
          <h3>
            <i class="fa fa-share-alt t-secondary mr-2" />
            Bookmark folders I'm invited to
            <span class="t-xs t-regular"><br />Collaborate on folders made by other colleagues</span>
          </h3>

          <div class="mt-3">
            <div v-for="(bookmarkFolder, index) in invitedFolders" :key="index">
              <hr class="my-3 bd-color-light hr-outlined" />
              <bookmark-item
                :researcher="researcher"
                :user="user"
                :bookmarkFolder="bookmarkFolder"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from '@/components/shared/Spinner'
import LinkButton from '@/components/shared/form/LinkButton'
import BookmarkItem from '@/components/user/bookmark_folder/Item'

import { mapGetters } from 'vuex'

export default {
  name: 'researcherBookmarkFolderOverview',
  components: {
    Spinner,
    LinkButton,
    BookmarkItem
  },
  props: {
    isLoaded: {
      type: Boolean,
      default: false
    },
    isBookmarkFoldersLoaded: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      required: true
    },
    researcher: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      invitedFolders: 'bookmarks/invitedFolders',
      userFolders: 'bookmarks/userFolders',
      otherBookmarkFolders: 'bookmarks/bookmarkFolders'
    }),
    canEdit () {
      return this.$can.edit('researcher', this.user.rw_access)
    },
    filteredUserFolders () {
      if (this.$currentUser && this.$currentUser.user_id === this.user.id) {
        // Fitler out private folders if we're viewing our own profile as guest
        if (this.$route.query.public) {
          return this.userFolders.filter(bm => !bm.is_private)
        }
        return this.userFolders
      }
      return this.otherBookmarkFolders
    }
  },
  methods: {
    handleCreate () {
      this.$events.$emit('modal:bookmark_folder:open:create')
    }
  }
}
</script>
